import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImageViewer from '../UI/ImageViewer/ImageViewer';
import './ArtworkCard.css';

const ArtworkCard = ({ artwork, onClick }) => {
    const { t } = useTranslation();
    const [viewerImage, setViewerImage] = useState(null);

    const handleImageClick = (e) => {
        e.stopPropagation();
        setViewerImage(artwork.images?.[0] || artwork.imageUrl);
    };

    const handleCardClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <>
            <div className="artwork-card" onClick={handleCardClick}>
                <div className="artwork-image-container">
                    <img
                        src={artwork.images?.[0] || artwork.imageUrl}
                        alt={artwork.title || 'Artwork'}
                        className="artwork-image"
                        onClick={handleImageClick}
                        onError={(e) => {
                            e.target.src = 'https://via.placeholder.com/400x400?text=Image+Not+Found';
                        }}
                    />
                    <div className="artwork-overlay" onClick={handleCardClick}>
                        <div className="artwork-card-actions">
                            <button
                                className="artwork-action-btn"
                                onClick={handleImageClick}
                                title={t('view_full_screen')}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="M21 21l-4.35-4.35" />
                                    <path d="M11 8v6M8 11h6" />
                                </svg>
                            </button>
                        </div>
                        {artwork.title && <span className="view-details">{artwork.title}</span>}
                    </div>
                </div>
            </div>

            <ImageViewer
                src={viewerImage}
                alt={artwork.title}
                onClose={() => setViewerImage(null)}
            />
        </>
    );
};

export default ArtworkCard;
